export type SoundEffect = "diceRoll" | "diceStop" | "move" | "select" | "capture" | "invalid" | "turn" | "home" | "victory" | "button";

/** Small synthesized placeholders: no downloaded or licensed assets are required. */
export class AudioFeedback {
  private context: AudioContext | null = null;
  private enabled = true;

  setEnabled(enabled: boolean): void { this.enabled = enabled; }

  play(effect: SoundEffect): void {
    if (!this.enabled) return;
    try {
      this.context ??= new AudioContext();
      const now = this.context.currentTime;
      const config: Record<SoundEffect, readonly [number, number, number]> = {
        diceRoll: [120, 80, 0.05], diceStop: [280, 145, 0.12], move: [410, 560, 0.06],
        select: [640, 790, 0.08], capture: [180, 70, 0.17], invalid: [150, 100, 0.12],
        turn: [370, 540, 0.13], home: [620, 990, 0.22], victory: [420, 1180, 0.42], button: [520, 700, 0.05],
      };
      const [from, to, duration] = config[effect];
      const oscillator = this.context.createOscillator();
      const gain = this.context.createGain();
      oscillator.type = effect === "capture" ? "sawtooth" : "sine";
      oscillator.frequency.setValueAtTime(from, now);
      oscillator.frequency.exponentialRampToValueAtTime(to, now + duration);
      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(effect === "capture" ? 0.15 : 0.09, now + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
      oscillator.connect(gain).connect(this.context.destination);
      oscillator.start(now); oscillator.stop(now + duration + 0.02);
    } catch { /* Audio is optional until a browser user gesture unlocks it. */ }
  }
}

export function vibrate(pattern: number | number[]): void {
  if ("vibrate" in navigator) navigator.vibrate(pattern);
}
